<h2 mat-dialog-title>Edit Description</h2>
<div class="images-grid" mat-dialog-content>
  <form [formGroup]="editForm">
    <mat-form-field class=" image-item full-width">
      <textarea rows="22" matInput formControlName="description"></textarea>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-button (click)="save()" color="primary">Save</button>
</div>
